/**
 * Utility functions for authentication
 */

import { authService } from "../api/services/authService";

/**
 * Logs out the user by calling the logout API, clearing all auth data, and redirecting to login
 * This is used when refresh token expires or authentication fails
 * If the logout API call fails (e.g., refresh token already expired), it still clears local storage
 */
export const logout = async (): Promise<void> => {
  const refreshToken = localStorage.getItem("refreshToken");

  try {
    // Try to call the logout API to invalidate the refresh token on the server
    // Only attempt if we have a refresh token
    if (refreshToken) {
      await authService.logout();
    }
  } catch (error) {
    // If logout API fails (e.g., refresh token expired), continue with local cleanup
    console.warn(
      "Logout API call failed, proceeding with local cleanup:",
      error
    );
  } finally {
    // Always clear all authentication data from localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("profile");

    // Clear all localStorage data (optional - uncomment if needed)
    // localStorage.clear();

    // Redirect to login page
    window.location.href = "/login";
  }
};
